import { Faker, pt_BR, en } from "@faker-js/faker";

// seed reservations:
// auth           = 1000
// external       = 1001
// clients        = 1002
// users          = 1003

const createFaker = (seed: number) => {
  const f = new Faker({ locale: [pt_BR, en] });
  f.seed(seed);
  return f;
};

export const fakers = {
  auth: createFaker(1000),
  external: createFaker(1001),
  clients: createFaker(1002),
  users: createFaker(1003),
};